module.exports = __webpack_public_path__ + "fonts/UcCo3FwrK3iLTcvvYwYZ8UA3J58.81d2852.woff2";